/**
 * Session Drawer Component
 * Full-screen drawer for recording reading sessions
 *
 * Layout (ตามรูปอ้างอิง):
 * - Header: ปิด (ซ้าย) | ชื่อหน้า (กลาง) | ช่วยเหลือ (ขวา)
 * - Session Info Card: วันที่, Session N, Last page recorded
 * - Form: Start Page (ล็อค), End Page, Session Impact
 * - ปุ่มบันทึก
 */

import {
  Sheet,
  SheetContent,
} from '@/components/ui/sheet';
import { X } from 'lucide-react';
import SessionForm from './SessionForm';
import { cn } from '@/lib/utils';

interface SessionDrawerProps {
  open: boolean;
  onClose: () => void;
}

export function SessionDrawer({ open, onClose }: SessionDrawerProps) {
  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent
        side="bottom"
        className={cn(
          'h-screen overflow-y-auto flex flex-col p-0',
          '[&>:first-child]:hidden'
        )}
      >
        {/* Header: Title (center) | Close (right) */}
        <div className="flex items-center justify-center shrink-0 px-4 py-4 border-b border-border relative">
          <h2 className="text-lg font-semibold text-foreground">
            บันทึกการอ่าน
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 p-2 rounded-md hover:bg-muted transition-colors focus:outline-none focus:ring-2 focus:ring-ring cursor-pointer"
            aria-label="ปิด"
          >
            <X className="h-5 w-5 text-foreground" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-4 py-6">
          <SessionForm open={open} onSuccess={onClose} />
        </div>
      </SheetContent>
    </Sheet>
  );
}

export default SessionDrawer;
